import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './NoticeBoradMovieDetail.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import BoardTypeDetailBox from '../../../../components/box/BoardTypeDetailBox';
import { useLocation } from 'react-router-dom';

import ToastPopup from '../../../../components/comm/ToastPopup';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';

import { SERVER_URL } from '../../../../constants/url';

import { normalizeVideoUrlForIframe } from '../../../../assets/js/comm';

const NoticeBoradMovieDetail = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const location = useLocation();
    const { state } = location;

    // 로컬 기준 76 동영상 102 url
    //const cntsNttId = state?.cntsNttId ?? 102;

    const [searchNtt, setSearchNtt] = useState({
        cntsNttId: state?.cntsNttId ?? null
        , usrInfoId: user?.usrInfoId ?? null
        , cntsSndngHistId: state?.idx ?? null
        , cnfrmAt: state?.cnfrmAt ?? null
    });

    // toast
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [contentsInfo, setContentsInfo] = useState({
        cntsSj: "",
        cntsUrl: "",
        rgstMthdCd: ""
    });


    const [src, setSrc] = useState("");

    useEffect(() => {
        if (!searchNtt?.cntsNttId) {
            setToastMessage('잘못 된 접근입니다.');
            setToast(true);
            return;
        }
        getContentsInfo();
    }, [searchNtt?.cntsNttId])

    const getContentsInfo = useCallback(async () => {

        const url = "/homecare/guide/retrieveContentsInfo";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                'Authorization': 'Bearer ' + jToken,
            }
        }

        await axiosApi.post(url, { ...searchNtt }, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {

                    const contInfo = res.data.result.contInfo;

                    const filse = contInfo.fileList;

                    let src = "";

                    if (contInfo.rgstMthdCd === 'U') {
                        src = normalizeVideoUrlForIframe(contInfo.cntsUrl);
                    } else if (contInfo.rgstMthdCd === 'F' && filse.length === 0) {
                        setToastMessage('첨부된 파일이 없습니다.');
                        setToast(true);
                        return;
                    } else {
                        src = SERVER_URL + `/cmm/fms/getVideo?atchFileStr=${filse[0].atchFileStr}&fileSn=${filse[0].fileSn}`;
                    }

                    setSrc(src);

                    setContentsInfo(contInfo);
                } else {
                    setToastMessage(res.data.resultMessage);
                    setToast(true);
                }
            })
            .catch(err => {
            })

    }, [searchNtt]);

    // if(!cntsNttId) return null;

    return (
        <>
            <HeadSub title="상세 보기" />

            <div id="sub-content" data-layout="white">

                <div className="inner-wrap" data-padding="0">


                    <div className={style['height-box']}>
                        <div className={style['notice_tit_box']}>
                            <p>{contentsInfo.cntsSj}</p>
                        </div>

                        <div className={style['video-wrap']}>
                            <div className={style['inner-box']}>

                                {/* <div className={style['video-frame']} >
                                    <iframe
                                        width="859"
                                        height="621"
                                        src="https://www.youtube.com/embed/o9csAaEl5fI"
                                        title="[건강 매거진] 탕후루 자주 먹으면 젊은 당뇨병 오나요?"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowfullscreen
                                    ></iframe>
                                </div> */}
                                {contentsInfo.rgstMthdCd === 'U' &&
                                    <div className={style['video-frame']} >
                                        <iframe
                                            width="859"
                                            height="621"
                                            src={src} // 또는 유터브 url
                                            title="video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" // ✅ fullscreen 추가
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                }

                                {/* 동영상 */}
                                {contentsInfo.rgstMthdCd === 'F' &&
                                    <div className={style['video-frame']}>
                                        <video muted controls>
                                            <source src={src} type="video/mp4" />
                                        </video>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    position="center"
                    message={toastMessage}
                />
            )}
        </>
    );
};

export default NoticeBoradMovieDetail;
